import React from 'react'
import styles from "../css/AuthScreen.module.css"
import UseMobileLayout from '../../../hooks/useMobileLayout'
import { useEffect } from 'react'
const AuthScreen = ({form,floatingContent}) => {

    return (
        <div className = {`${styles.wrapper} auth-screen`}>
            <div className={`${styles.blob} ${styles.blobTopLeft}`}></div>
            <div className={`${styles.blob} ${styles.blobTopRight}`}></div>
            <div className={`${styles.blob} ${styles.blobBottomLeft}`}></div>
            <div className={`${styles.blob} ${styles.blobBottomRight}`}></div>
            <div className = {styles.mainContainer}>
                <div className = {styles.box}>
                    <div className = {styles.leftPanel}>
                        {form}
                    </div>
                    <div className = {styles.rightPanel}>
                        <div className = {styles.blob}></div>
                        <div className = {styles.blob}></div>
                        <div className = {styles.blob}></div>
                        {floatingContent}
                    </div>
                </div>
            </div>
        </div>
  )
}

export default AuthScreen